module.exports = __webpack_public_path__ + "img/bussiness.42a8811b.png";